import {
   getCoursesFromClient,
   GetCoursesRequestOptions,
   getCourses,
} from '~/pages/api/courses/_shared/getCourses.api';
import { QueryClient, useQuery } from '@tanstack/react-query';

export function getPaginatedCoursesKey(options: GetCoursesRequestOptions) {
   return ['courses', ...Object.values(options)];
}

export function usePaginatedCourses(options: GetCoursesRequestOptions = {}) {
   const queryFunction = async () => {
      return await getCoursesFromClient(options);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: getPaginatedCoursesKey(options),
      refetchOnWindowFocus: false,
   });
}

export async function prefetchPaginatedCourses(
   queryClient: QueryClient,
   options?: GetCoursesRequestOptions
): Promise<void> {
   options ??= {
      orderby: 'title',
      direction: 'ASC',
      disabledOkay: true,
      userid: null,
      pageSize: 25,
      page: 1,
   };
   await queryClient.prefetchQuery(getPaginatedCoursesKey(options), () => getCourses(options));
}
